import React from 'react'

import { AboutSection } from './components/sections/About'
import { AiSection } from './components/sections/Ai'
import { HeaderSection } from './components/sections/Header'
import { NoxsysSection } from './components/sections/Noxsys'
import { OfferSection } from './components/sections/Offer'
import { SupportSection } from './components/sections/Support'

import './components/sections/index.css'
import { Header } from './components/Header'

const NewHomePage: React.FC = () => {
    return (
        <div className="flex flex-col gap-4 bg-white pt-24">
            <HeaderSection className="flex lg:hidden" />
            <Header className="hidden lg:flex" />
            <AboutSection />
            <NoxsysSection />
            <OfferSection />
            <AiSection />
            <SupportSection />
        </div>
    )
}

export default NewHomePage
